import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { About } from '../components/About';
import { Legacy } from '../components/Legacy';
import { MenuHighlights } from '../components/MenuHighlights';
import { CtaPanels } from '../components/CtaPanels';
import { Gallery } from '../components/Gallery';
import { Testimonials } from '../components/Testimonials';
import { LocationSection } from '../components/LocationSection';
import { Footer } from '../components/Footer';
import { MobileBottomBar } from '../components/MobileBottomBar';

export default function Home() {
  return (
    <main data-testid="home-page" className="relative bg-brand-cream text-brand-coffee">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Legacy />
      <MenuHighlights />
      <CtaPanels />
      <Gallery />
      <Testimonials />
      <LocationSection />
      <Footer />
      <MobileBottomBar />
    </main>
  );
}
